import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'pp-text-area',
  templateUrl: './text-area.component.html',
  styles: ':host { width: 100% }',
  imports: [CommonModule, ReactiveFormsModule],
})
export class TextAreaComponent {

  readonly description = input('');
  readonly form = input.required<FormGroup>();
  readonly formatPlaceholder = input('');
  readonly id = input.required<string>();
  readonly label = input('');
  readonly labelIsHidden = input(false);
  readonly maxLength = input<number>();
  readonly placeholder = input('');
  readonly rows = input(3);

  get currentLength(): number {
    return this.form()?.get(this.id())?.value?.length ?? 0;
  }

  get isOverLimit(): boolean {
    const max = this.maxLength();
    return !!max && this.currentLength > max;
  }
}
